import React from "react";
import { Outlet } from "react-router-dom";

const PartnerRoot = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default PartnerRoot;
